import { render } from "./BcomAdvancedFinanceandAccountingView.vue?vue&type=template&id=d0554018"
import script from "./BcomAdvancedFinanceandAccountingView.vue?vue&type=script&lang=js"
export * from "./BcomAdvancedFinanceandAccountingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__